"use client"

import "./headerStyle.css"

export const Header = () => {
  const handleButtonClick = () => {
    window.location.href = "tel:0995-47-5013"
  }

  return (
    <header className="bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <button
            onClick={handleButtonClick}
            className="bg-white text-orange-600 hover:bg-orange-50 font-bold text-lg px-8 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105 flex items-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>
            電話で注文する
          </button>

          <div className="flex items-center gap-2 text-center md:text-right">
            <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12,6 12,12 16,14"></polyline>
            </svg>
            <div className="text-sm md:text-base">
              <div className="font-semibold">営業時間: 11:00 〜 14:00 16:00 〜 19:30</div>
              <div className="text-orange-100">電話のラストオーダーは19:00まで</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
